import React from "react";
import PropTypes from "prop-types";

function TableReportDataPeriod(props) {
  const { dateArr } = props;
  return (
    <div className="table-report-data-period">
      {dateArr[0] && (
        <table>
          <tr>
            <td>من تاريخ</td>
            <th>{dateArr[0]}</th>
          </tr>
        </table>
      )}

      {dateArr[1] && (
        <table>
          <tr>
            <td>إلى تاريخ</td>
            <th>{dateArr[1]}</th>
          </tr>
        </table>
      )}
    </div>
  );
}

TableReportDataPeriod.defaultProps = {
  dateArr: [],
};
TableReportDataPeriod.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  dateArr: PropTypes.array,
};

export default TableReportDataPeriod;
